import React from 'react';
import CostAdjustmentApi from "../../api/costAdjustmentapi";
import { Table } from 'reactstrap';
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

class CostAdjustmentView extends React.Component {
  constructor() {
    super();
    this.state = {
      costAdjustments: [],
    }

    this.costAdjustmentApi = new CostAdjustmentApi();
  }

  componentDidMount() {
    const productId = this.props.match.params.productId;
    console.log(productId);
    this.costAdjustmentApi.getCostAdjustmentsByProductId(productId).then(response => {
      const costAdjustments = response.data
      console.log(costAdjustments);
      this.setState({
        costAdjustments
      });
    });
  }

  renderCostAdjustments = () => {
    return this.state.costAdjustments.map((costAdjustment) => {
      const productId = this.props.match.params.productId;
      return (
        <tr key={costAdjustment.costAdjustmentId}>
          <td>
            <Link to={`/costAdjustmentEdit/${productId}/${costAdjustment.costAdjustmentId}`}>{costAdjustment.adjustmentType}</Link>
          </td>
          <td>
            <Link to={`/costAdjustmentEdit/${productId}/${costAdjustment.costAdjustmentId}`}>{costAdjustment.adjustment}</Link>
          </td>
        </tr>
      );
    });
  };


  render() {
    const productId = this.props.match.params.productId;
    console.log(this.props.match.params.id);
    return (

      <div className="col-md-12">
        <div className="col-md-6">
          <Link to={`/costAdjustmentCreate/${productId}`} className="ml-5 float-right">
            <FontAwesomeIcon size="sm"
              icon="plus"
            />
            New CostAdjustment
                  </Link>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th className="text-center">CostAdjustment Type</th>
                <th className="text-center">Adjustment</th>
              </tr>
            </thead>
            <tbody>
              {this.renderCostAdjustments()}
            </tbody>
          </Table>
        </div>
      </div>
    );


  }

}

export default CostAdjustmentView;
